module.exports = __webpack_public_path__ + "img/soundcloud.5468aa2c.svg";